// リール型・タイル型両方に適用するビューア/挙動判定
export const isReelLike = (frame) => frame === 'square' || frame === 'tile';
